import MaterialUIListItemText from '@material-ui/core/ListItemText';
import { Theme, withStyles } from '@material-ui/core/styles';

const styles = (theme: Theme) => ({
  inset: {
    '&:first-child': {
      paddingLeft: theme.spacing(5)
    }
  },
  root: {
    padding: `0 ${theme.spacing(1)}px`,
    width: '100%'
  },
  primary: {
    fontSize: theme.typography.pxToRem(14)
  }
});

export const ListItemText = withStyles(styles)(MaterialUIListItemText);
